import baseApi from 'api/baseApi';
import { IProfileInfo } from 'common/components/PersonProfile/interfaces';
import { IUnredeemDto } from 'modules/reports/interfaces/usedSessionsReport';

const ProfileServiceApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    unredeemFrontDeskService: builder.mutation<
      Partial<IProfileInfo>,
      { data: IUnredeemDto; personId: number; redemptionId: number }
    >({
      query: ({ data, personId, redemptionId }) => ({
        url: `/api/v1/front-desk/${personId}/service-section/redemptions/${redemptionId}/unredeem`,
        method: 'PUT',
        data,
      }),
    }),
    unredeemLeadService: builder.mutation<
      Partial<IProfileInfo>,
      { data: IUnredeemDto; personId: number; redemptionId: number }
    >({
      query: ({ data, personId, redemptionId }) => ({
        url: `/api/v1/leads/${personId}/service-section/redemptions/${redemptionId}/unredeem`,
        method: 'PUT',
        data,
      }),
    }),
    unredeemMemberService: builder.mutation<
      Partial<IProfileInfo>,
      { data: IUnredeemDto; personId: number; redemptionId: number }
    >({
      query: ({ data, personId, redemptionId }) => ({
        url: `/api/v1/members/${personId}/service-section/redemptions/${redemptionId}/unredeem`,
        method: 'PUT',
        data,
      }),
    }),
    unredeemPTLeadService: builder.mutation<
      Partial<IProfileInfo>,
      { data: IUnredeemDto; personId: number; redemptionId: number }
    >({
      query: ({ data, personId, redemptionId }) => ({
        url: `/api/v1/pt-leads/${personId}/service-section/redemptions/${redemptionId}/unredeem`,
        method: 'PUT',
        data,
      }),
    }),
  }),
});

export const {
  useUnredeemFrontDeskServiceMutation,
  useUnredeemLeadServiceMutation,
  useUnredeemMemberServiceMutation,
  useUnredeemPTLeadServiceMutation,
} = ProfileServiceApi;
